// lib
import React from "react";
import PropTypes from "prop-types";
import { ListItem, ListItemText } from "@material-ui/core";

const CategoryLine = ({ category }) => (
  <ListItem className="category">
    <div className="border-category" />
    <ListItemText>{category.name}</ListItemText>
  </ListItem>
);

CategoryLine.propTypes = {
  // parent props
  category: PropTypes.object.isRequired,
};

export default CategoryLine;
